{
  "max100Characters": "最多可输入100个字符",
  "noSpecialOrNumbers": "不能包含特殊符号或数字",
  "noSpecialCharacters": "不能包含特殊符号",
  "digitsOnly": "请输入数字",
  "max30Digits": "最多可输入30个数字",
  "max254Characters": "最多可输入254个字符",
  "max15Digits": "最多可输入15个数字",
  "exactly16Digits": "请输入16个数字",
  "fiveToTenDigits": "请输入5~10个数字",
  "accountAlreadyAdded": "该{{method}}已添加过了，请重新输入",
  "qrCodeNotFound": "找不到收款码",
  "uploadReceivingCode": "上传收款码",
  "reupload": "重新上传",
  "confirm": "确认",
  "namePlaceholder": {
    "bank": "请输入持卡人姓名",
    "alipay": "请输入支付宝实名认证姓名",
    "wechat": "请输入微信实名认证姓名",
    "ermb": "请输入数字人民币实名认证姓名",
    "qq": "请输入QQ实名认证姓名"
  },
  "accountLabel": {
    "bank": "银行卡号",
    "alipay": "支付宝账号",
    "wechat": "微信手机号",
    "ermb": "钱包编号",
    "qq": "QQ号码"
  },
  "maximumTwenty": "最多只能设置20个",
  "title": "收付款方式",
  "transactionPasswordIncorrect": "交易密码错误",
  "retryMinutes": "{{count}} 分钟",
  "retryHours": "{{count}} 小时",
  "transactionPasswordLocked": "交易密码已暂时锁定，请稍后重试或重置交易密码",
  "transactionPasswordLockedUntil": "交易密码已暂时锁定，请在 {{delay}}后重试，或重置交易密码",
  "transactionPasswordLastAttempt": "交易密码错误，仅剩 1 次尝试机会；再次输错将暂时锁定",
  "transactionPasswordAttemptsRemaining": "交易密码错误，还可尝试 {{count}} 次",
  "refresh": "刷新",
  "selectedReceivingMethodCount": "{{count}}个收款方式",
  "add": "添加",
  "matchingNameHint": "只会显示与您身份认证的姓名一致的付款方式，如果列表中找不到所需的，请添加一个与认证的姓名一致的付款方式。",
  "noPaymentMethods": "暂无收付款方式",
  "addPaymentMethod": "添加收付款方式",
  "selected": "已选择",
  "added": "收付款方式添加成功",
  "addFailed": "收付款方式添加失败",
  "deleted": "收付款方式删除成功",
  "deleteFailed": "收付款方式删除失败",
  "updated": "收付款方式修改成功",
  "updateFailed": "收付款方式修改失败",
  "confirmDelete": "确认删除收付款方式",
  "confirmDeleteDescription": "您确定要删除此收付款方式吗？{{lastOne}}",
  "lastPaymentMethod": "这是您的最后一个收付款方式。",
  "delete": "删除",
  "receivingCodeLabel": {
    "alipay": "支付宝收款码",
    "wechat": "微信收款码",
    "qq": "QQ收款码"
  }
}
